import { render, staticRenderFns } from "./AlertEventDialogExcludedRulesTabComponent.vue?vue&type=template&id=64547f34&scoped=true"
import script from "./AlertEventDialogExcludedRulesTabComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogExcludedRulesTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogExcludedRulesTabComponent.vue?vue&type=style&index=0&id=64547f34&prod&scoped=true&lang=scss"
import style1 from "./AlertEventDialogExcludedRulesTabComponent.vue?vue&type=style&index=1&id=64547f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64547f34",
  null
  
)

export default component.exports